import { useEffect } from "react";
import { Col, Form } from "antd";
import CustomSelect from "../../../components/CustomSelect.jsx";
import AiAssistance from "./AiAssistance.jsx";

const NotificationMethodSection = ({
  form,
  selected,
  notificationOptions,
  shipment,
  selectedNotificationMethod,
  setSelectedNotificationMethod,
  selectedOption,
  setSelectedOption,
  setAiMessage,
  aiMessage,
}) => {
  const DEFAULT_AI_MESSAGE = `[Insert your message here]

Shipment Details
- Shipment: {{transport_provider_tracking_id}}
- From: {{origin}} (departure: {{pickup_date}})
- To: {{destination}} (delivery: {{estimated_delivery_date}})
- (OPTIONAL) Temperature Requirements: {{min_temp}}–{{max_temp}}°C`;

  const handleSelectChange = (value) => {
    setSelectedOption(value);
    setSelectedNotificationMethod(value);
    form.setFieldsValue({
      team_members: [],
      users: [],
    });
    const isOldMobileType =
      selectedOption === "MOBILE" || selectedOption === "WHATSAPP";
    const isNewMobileType = value === "MOBILE" || value === "WHATSAPP";
    if (isOldMobileType !== isNewMobileType) {
      form.setFieldsValue({ notification_channel: "" });
    }
  };

  return (
    <>
      <Col span={24}>
        <Form.Item
          className="custom-input form-input-style"
          label="Notify via"
          name="notification_method"
          rules={[
            {
              required: true,
              message: "Please select a notification method",
            },
          ]}
        >
          <CustomSelect
            options={notificationOptions}
            placeholder="Select"
            onChange={handleSelectChange}
            width="100%"
            height="36px"
            border="0px"
            bgColor="#F3F3F3"
            textColor="#5E5E5E"
            borderRadius="8px"
            placeholderColor="#4B4B4B"
          />
        </Form.Item>
      </Col>

      {(selectedNotificationMethod === "AI_EMAIL" ||
        selectedNotificationMethod === "AI_CALL") && (
        <Col span={24} style={{ marginBottom: "16px" }}>
          <AiAssistance
                   shipment={shipment}
            aiMessage={aiMessage}
            setAiMessage={setAiMessage}
            selected={selected}
            selectedNotificationMethod={selectedNotificationMethod}
            onMessageChange={(msg) => setAiMessage(msg)}
            defaultMessage={DEFAULT_AI_MESSAGE}
          />
        </Col>
      )}

      {(selectedOption === "TEAMS" || selectedOption === "SLACK") && (
        <Col span={24}>
          <p
            style={{
              color: "#5E5E5E",
              fontSize: "12px",
              position: "relative",
              bottom: "10px",
              marginBottom: "0px",
            }}
          >
            A ZoomLogi representative will contact you.
          </p>
        </Col>
      )}
    </>
  );
};

export default NotificationMethodSection;
